import React, { useState, useEffect } from "react";
import Layout from "Components/Layout";
import { Helmet } from "react-helmet";
import Styles from "./Payouts.module.css";
import { useForm } from "react-hook-form";
import ReactLoading from "react-loading";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { FcExport } from "react-icons/fc";
import ModalLoad from "Components/loader/loader";
import {
    SuccessSwal,
    warningSwal,
    ConfirmationDiaolog,
    Error_Dark,
} from "Util/Toast";
import { Services } from "../../Services";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";

function Payouts() {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();
    const [loading, setLoading] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);
    const navigate = useNavigate();
    const [Payouts, setPayouts] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [body, setBody] = useState({});
    const [csvData, setCsvData] = useState([]);

    const token = {
        Authorization: `token ${localStorage.getItem("token")}`,
    };
    useEffect(() => {
        const commonObjects = Payouts.filter((obj) =>
            selectedRows.includes(obj.TutorID)
        );
        console.log(commonObjects);
        setCsvData([
            ["TUTOR ID", "NAME", "TOTAL EARNING", "TDS", "AMOUNT TO PAY"],
            ...commonObjects.map((item) => [
                item?.TutorID,
                `${item?.TutorName}`,

                parseFloat(item?.TotalEarnings),
                item?.TDSAmount,
                item?.NetPayable,
            ]),
        ]);
    }, [selectedRows]);
    const onSubmit = (data) => {
        setSelectedRows([]);
        const fromMoment = moment(data.FromDate);
        const toMoment = moment(data.ToDate);

        // Check if they are in the same month and year
        if (!fromMoment.isSame(toMoment, "month")) {
            warningSwal(
                "warning",
                "From Date and To Date should be of same month"
            );
            return;
        }
        setLoading(true);
        let body = { ...data, Month: fromMoment.format("MMMM") };
        setBody(body);
        Services.Create_bulkpayouts("POST", JSON.stringify(body), token)
            .then((response) => {
                setLoading(false);
                if (response.Status === 1) {
                    setPayouts(response?.TutorPayoutAmounts);
                    // SuccessSwal("Success", response.Message);
                    // navigate(-1);
                } else if (response.Status === 0) {
                    setLoading(false);
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                // alert(err);
                setLoading(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const handleSelectRow = (id) => {
        setSelectedRows((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((rowId) => rowId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };
    const handleSelectAll = () => {
        if (selectedRows.length === Payouts.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(Payouts.map((item) => item.TutorID));
        }
    };
    const FinalizePayment = () => {
        const commonObjects = Payouts.filter((obj) =>
            selectedRows.includes(obj.TutorID)
        );
        setLoadingModal(true);
        Services.bulkpayouts(
            "POST",
            JSON.stringify({ TutorIDs: commonObjects, ...body }),
            token
        )
            .then((response) => {
                setLoadingModal(false);
                if (response.Status === 1) {
                    // setPayouts(response?.TutorPayoutAmounts);
                    SuccessSwal("Success", response.Message);
                    navigate(-1);
                } else if (response.Status === 0) {
                    setLoading(false);
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                // alert(err);
                setLoadingModal(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const ConfirmPayments = () => {
        if (selectedRows.length == 0) {
            Error_Dark("Plese Select atleast one record");
            return;
        }
        ConfirmationDiaolog(
            "Are you sure you want to finalise the payouts?",
            "Finalise Payment",
            FinalizePayment
        );
    };
    return (
        <Layout Active={"bulk-payouts"}>
            {" "}
            {loadingModal && <ModalLoad />}
            <Helmet>
                <meta charSet="utf-8" />
                <title>Bulk Payouts</title>
            </Helmet>
            <div className={Styles["Container"]}>
                <div className={Styles["wrapper"]}>
                    <h3 style={{ display: "flex", gap: "0.5rem" }}>
                        Bulk Payouts{" "}
                    </h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="First Name">
                                From Date <span className="important">*</span>
                            </label>
                            <input
                                type="date"
                                {...register("FromDate", {
                                    required: "this field is required",
                                })}
                            />
                            {errors.FromDate && (
                                <span>{errors.FromDate.message}</span>
                            )}
                        </div>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="First Name">
                                To Date <span className="important">*</span>
                            </label>
                            <input
                                type="date"
                                {...register("ToDate", {
                                    required: "this field is required",
                                })}
                            />
                            {errors.ToDate && (
                                <span>{errors.ToDate.message}</span>
                            )}
                        </div>
                        <button disabled={loading}>
                            {" "}
                            {loading ? (
                                <ReactLoading
                                    color="green"
                                    type="spokes"
                                    height={30}
                                    width={30}
                                />
                            ) : (
                                "Submit"
                            )}
                        </button>
                    </form>
                    <h3>Payouts</h3>
                    {Payouts.length > 0 && (
                        <div
                            className={Styles["Table"]}
                            style={{
                                maxHeight: "350px",
                                overflow: "auto",
                            }}>
                            <table
                                style={{
                                    // maxHeight: "300px",
                                    overflow: "auto",
                                }}>
                                <thead>
                                    <tr style={{ position: "sticky", top: 0 }}>
                                        <th>
                                            {" "}
                                            <input
                                                type="checkbox"
                                                checked={
                                                    selectedRows.length ===
                                                    Payouts.length
                                                }
                                                onChange={handleSelectAll}
                                            />
                                        </th>
                                        <th>Tutor ID</th>
                                        <th>Name</th>
                                        <th>Total earning</th>
                                        <th>TDS</th>
                                        <th>Net payable</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        [1, 1].map((item) => (
                                            <tr className={Styles["loading"]}>
                                                <td>
                                                    <Skeleton />
                                                </td>
                                                <td>
                                                    <Skeleton />
                                                </td>

                                                <td>
                                                    <Skeleton />
                                                </td>
                                                <td>
                                                    <Skeleton />
                                                </td>
                                            </tr>
                                        ))
                                    ) : Payouts.length > 0 ? (
                                        Payouts.map((item) => (
                                            <tr>
                                                <td>
                                                    {" "}
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedRows.includes(
                                                            item.TutorID
                                                        )}
                                                        onChange={() =>
                                                            handleSelectRow(
                                                                item.TutorID
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td>{item?.TutorID}</td>
                                                <td>{item?.TutorName}</td>
                                                <td>
                                                    {parseFloat(
                                                        item?.TotalEarnings.toFixed(
                                                            2
                                                        )
                                                    )}
                                                </td>
                                                <td>{item?.TDSAmount}</td>
                                                <td>{item?.NetPayable}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5}>No Record Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "1rem",
                            justifyContent: "center",
                            marginTop: "1rem",
                        }}>
                        <button
                            disabled={selectedRows.length == 0}
                            onClick={ConfirmPayments}
                            style={{
                                width: "fit-content",
                                justifySelf: "center",
                                padding: "0.3rem",
                                borderRadius: "10px",
                                border: "1px solid #ccc",
                            }}>
                            Finalise Payouts
                        </button>
                        {selectedRows.length > 0 && (
                            <CSVLink
                                style={{
                                    height: "0.6rem",
                                    background: "#0077b6",
                                    color: "white",
                                    textDecoration: "none",
                                    fontSize: "0.9rem",
                                    borderRadius: "10px",
                                }}
                                filename="Payout"
                                className={Styles["button"]}
                                data={csvData}>
                                Export
                            </CSVLink>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Payouts;
